import React from 'react';
import StatusBasedProjects from './StatusBasedProjects';

const UnassignedProjects = () => {
  return (
    <StatusBasedProjects 
      status="UNASSIGNED"
      title="Unassigned Projects"
    />
  );
};

export default UnassignedProjects;